import React from "react";

const HasError = () => {
  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center"
      dir="rtl"
      style={{ minHeight: "85vh" }}
    >
      <div>
        <h1 className=" text-center">
          با عرض پوزش در بارگزاری داده ها خطایی رخ داده است!
        </h1>
      </div>
      <div>
        <h4 className=" text-center">
          لطفا وضعیت اتصال به اینترنت را چک نمایید و یا در صورت استفاد از
          فیلترشکن آن را قطع نمایید.
        </h4>
      </div>
    </div>
  );
};

export default HasError;
